// Shared API base URL helper.
// Production hosts use a relative `/api` prefix; preview hosts use REACT_APP_BACKEND_URL.
export const getApiUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (
      hostname === "sportsguru247.com" ||
      hostname.includes("deploy.emergentcf.cloud") ||
      hostname.includes("sportsguru")
    ) {
      return "/api";
    }
  }
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  return backendUrl ? `${backendUrl}/api` : "/api";
};

export const API = getApiUrl();
